import * as React from 'react';
import FormControl, { useFormControl } from '@mui/material/FormControl';
import OutlinedInput from '@mui/material/OutlinedInput';
import FormHelperText from '@mui/material/FormHelperText';
import { InputLabel } from '@mui/material';

function MyFormHelperText() {
    const { focused } = useFormControl() || {};

    const helperText = React.useMemo(() => {
        if (focused) {
            return 'This field is being focused';
        }

        return 'Helper text';
    }, [focused]);

    return <FormHelperText>{helperText}</FormHelperText>;
}
export default function InputBox(props) {
    const [value, setValue] = React.useState(props.duration);

    const preventMinus = (e) => {
        if (e.code === 'Minus') {
            e.preventDefault();
        }
    };

    const preventPasteNegative = (e) => {
        const clipboardData = e.clipboardData || window.clipboardData;
        const pastedData = parseFloat(clipboardData.getData('text'));

        if (pastedData < 0) {
            e.preventDefault();
        }
    };
    return (
        <form noValidate autoComplete="off">
            <InputLabel className='__Input-label' id="label">{props.label}</InputLabel>

            <FormControl >
                <OutlinedInput
                    rows={3}
                    type='number'
                    className='_InputBox'
                    placeholder="Number of days"
                    value={value}
                    onChange={(e) => {
                        if (e.target.valueAsNumber < 0) {
                            e.preventDefault();
                        }else{
                            setValue(e.target.value)
                            props.onChange(e)
                        }
                    }}
                    onPaste={preventPasteNegative}
                    onKeyDown={preventMinus}
                />
                {/* <MyFormHelperText /> */}
            </FormControl>
        </form>
    );
}